/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';

export type KiteTrxInfo = {
    TRXHA: string;
    STAT: KiteTrxInfo.STAT;
    MTH: string;
    BNO: string;
    AG: string;
    ADDRSFROMINFO: EvmAddressSummaryInfo;
    ADDRSTOINFO: EvmAddressSummaryInfo;
    VAL: string;
    TRXF: string;
    UT: number;
    TRXID: string;
    SNO: string;
};

export namespace KiteTrxInfo {

    export enum STAT {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }


}

